/**
 * Configuração central de preços da produção terceirizada (Design/Vídeo).
 *
 * Único lugar do projeto onde valores em R$ devem existir — nenhum
 * componente ou util deve ter preço "espalhado" no código. Para ajustar um
 * valor no futuro, edite APENAS este arquivo.
 */

export const DESIGN_PRICING = {
  /** Etiqueta "Estático" */
  static: 35,
  /** Etiqueta "Capa de reel" — mesmo valor do Estático, mas contado à parte */
  reelCover: 35,
  /** Etiqueta "Carrossel", Qtd. telas 1–8 */
  carouselUpTo8: 45,
  /** Etiqueta "Carrossel", Qtd. telas 9–10 */
  carousel9To10: 50,
  /** Etiqueta "Story", Qtd. telas = 1 */
  storySingle: 35,
  /** Etiqueta "Story", Qtd. telas 2 ou mais (sem limite superior) */
  story2Plus: 50,
} as const

export const VIDEO_PRICING: {
  /** Quantidade mínima de vídeos no período para valer o preço de pacote */
  packageMinimum: number
  /** Preço por vídeo quando a quantidade atinge o pacote (packageMinimum) */
  packageUnitPrice: number
  /**
   * Preço por vídeo avulso (quantidade abaixo do pacote). Ainda não
   * definido — preencha aqui quando o valor for decidido; nenhuma outra
   * mudança de código é necessária para essa faixa passar a ter custo.
   */
  singleUnitPrice: number | null
} = {
  packageMinimum: 10,
  packageUnitPrice: 60,
  singleUnitPrice: null,
}
